import { useParams } from 'react-router-dom'
import { useControlQuestionAnswer, useProtocolRoom } from '@services/protocols/protocols.hook'
import { Box, Typography, IconButton } from '@mui/material'
import { useState, useMemo } from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'

function ProtocolControlQuestionsSummary() {
  const [isVisible, setVisible] = useState(false)
  const { id } = useParams<{ id: string }>()
  const { protocolRoom } = useProtocolRoom(Number(id))
  const { controlQuestionAnswer } = useControlQuestionAnswer(Number(id))

  const summary = useMemo(
    () =>
      controlQuestionAnswer.map((answer) => {
        const room = protocolRoom.find((room) => room.id === answer.room)
        return {
          ...answer,
          room: `${room?.roomInstance?.name} - ${room?.roomInstance?.nameLocal}`
        }
      }),
    [controlQuestionAnswer, protocolRoom]
  )

  if (!!controlQuestionAnswer.length) {
    return (
      <Box
        sx={{
          width: '100%',
          mb: 2
        }}
      >
        <Typography variant='subtitle1' fontWeight={600}>
          Usterki{' '}
          <IconButton onClick={() => setVisible((state) => !state)}>
            {isVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
          </IconButton>
        </Typography>
        {isVisible && (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr',
              gap: 2
            }}
          >
            {summary.map((answer) => (
              <Box key={answer.id}>
                <Typography
                  variant='caption'
                  sx={{
                    textTransform: 'uppercase',
                    fontWeight: 600
                  }}
                >
                  Pokój
                </Typography>
                <Typography variant='body2'>{answer.room}</Typography>
                <Typography
                  variant='caption'
                  sx={{
                    textTransform: 'uppercase',
                    fontWeight: 600
                  }}
                >
                  Komentarz
                </Typography>
                <Typography variant='body2'>{answer.comment}</Typography>
                <Typography
                  variant='caption'
                  sx={{
                    textTransform: 'uppercase',
                    fontWeight: 600
                  }}
                >
                  Pokrycie kosztów
                </Typography>
                <Typography variant='body2'>{answer.coveringCost}</Typography>
                <Typography
                  variant='caption'
                  sx={{
                    textTransform: 'uppercase',
                    fontWeight: 600
                  }}
                >
                  Scale
                </Typography>
                <Typography variant='body2'>{answer.scale}</Typography>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    )
  }

  return null
}

export default ProtocolControlQuestionsSummary
